import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses, mainIncludes, productName } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function OfferStack() {
  return <section aria-labelledby="stack-title" className="bg-paper" data-id="element-175" data-mp="2kvjz0vuwrzv7">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-176" data-mp="2ku90pbk8fkbh">
        <SectionHeading id="stack-title" title="Everything You Get" data-id="element-177" data-mp="1x6r2oyadjq02" />
        <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-1 ring-cream-line" data-id="element-178" data-mp="1t5xf660ugd7p">
          <div className="p-7 sm:p-10" data-id="element-179" data-mp="26xvjm3jm1kxj">
            <div className="flex items-center gap-3" data-id="element-180" data-mp="225u8iky6i093">
              <HeartMark className="h-6 w-6 text-coral" data-id="element-181" data-mp="2241296rh9i1m" />
              <h3 className="font-display text-3xl text-navy sm:text-4xl" data-id="element-182" data-mp="1efhpof1eaj3q">{productName}</h3>
            </div>
            <ul className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-183" data-mp="19hol1qfqpx5k">
              {mainIncludes.map(m => <li key={m} className="flex items-start gap-2.5 font-bold text-navy" data-id="element-184" data-mp="14o207nuzot0o">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-185" data-mp="19nn2o89dbji5" />
                  {m}
                </li>)}
            </ul>
          </div>
          <div className="border-t border-dashed border-cream-line bg-gold-wash/60 p-7 sm:p-10" data-id="element-186" data-mp="1je9avher97qt">
            <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-187" data-mp="lr0uu1xiwqw7">Plus 5 free bonuses</p>
            <ul className="mt-5 space-y-3.5" data-id="element-188" data-mp="qq3nso08b6nt">
              {bonuses.map(b => <li key={b.number} className="flex items-center gap-3 text-lg font-semibold text-navy" data-id="element-189" data-mp="vo5ffxbq0eaw">
                  <GiftIcon className="h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-190" data-mp="zr1sl8ihri7g" />
                  {b.name}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-12 flex justify-center" data-id="element-191" data-mp="2b44ac6wbudt7">
          <CtaButton data-id="element-192" data-mp="2b70a80rqjcka">Get Instant Access</CtaButton>
        </div>
      </div>
    </section>;
}